// extracted by mini-css-extract-plugin
export default {"logo":"logoWrapper_logo__4ZBSH"};